import React from 'react'
import { PopupWidget } from "react-calendly";
import Form from '../components/Form'
import { Helmet } from 'react-helmet-async'

function Auditing() {

    const services = [
        {
          title: 'Cybersecurity Advisory & Risk Management',
          image: 'https://i0.wp.com/www.institutedata.com/wp-content/uploads/2024/02/AU-cybersecurity-risk-management.png?fit=940%2C470&ssl=1',
          description: [
            'Comprehensive risk assessments leveraging frameworks like NIST CSF, NIST RMF, ISO 27001/2/5, ISO 31000, and CIS Controls.',
            'Tailored risk management strategies to mitigate vulnerabilities and enhance operational resilience.',
            'Vendor and third-party risk management solutions to secure your supply chain.',
          ],
        },
        {
          title: 'Information Security Management System (ISMS) Development',
          image: 'https://www.it-impresa.it/wp-content/uploads/ISMS-Information-Security-Management-System-1-800x469.jpg.webp',
          description: [
            'Implementation of robust ISMS frameworks tailored to your organizational needs.',
            'Establishment of security processes and standards to meet compliance and audit requirements.',
            'ISO 27001/2 readiness support to achieve and maintain certification.',
          ],
        },
        {
          title: 'Compliance and Certification Support',
          image: 'https://img.freepik.com/premium-photo/businessman-showcasing-iso-certification-quality-control-icon-assurance-top-service-compliance-with-international-standards-tablet-device-present-show-products-services-standards_143683-10865.jpg',
          description: [
            'Expert guidance for achieving compliance with regulatory and industry standards, including SOC 2, PCI DSS, HIPAA, and HITECH.',
            'Comprehensive audit preparation, documentation, and evidence management to ensure certification success.',
            'Policy and procedure development aligned with client and industry expectations.',
          ],
        },
        {
          title: 'Governance, Risk, and Compliance (GRC) Solutions',
          image: 'https://www.metricstream.com/sites/default/files/styles/raw_original_image/public/2024-05/top-governance-risk-compliance-grc-tools-dsk.webp?itok=AiPzsvxW',
          description: [
            'Seamless integration of GRC tools for effective risk monitoring and compliance tracking.',
            'Strategic alignment of cybersecurity policies with business objectives.',
            'Support for ongoing compliance with ISO 27001, SOC 2, PCI DSS, HIPAA, and other key standards.',
          ],
        },
        {
          title: 'Tailored Cybersecurity Consulting and Training',
          image: 'https://www.micromindercs.com/Uploads/Why%20Cybersecurity%20Training%20Matters.png',
          description: [
            'Custom training sessions to build awareness and expertise among your teams.',
            'Advisory engagements that align cybersecurity initiatives with organizational growth strategies.',
            'Development of client-specific deliverables, including detailed reports and actionable insights.',
          ],
        },
        {
          title: 'Professional IT Audit Consulting',
          image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTV9fbONttgQI3iEtTUFtpqUl_9-yjz98EAw&s',
          description: [
            'Comprehensive IT audit services designed to assess and enhance your organization\'s security posture and compliance readiness.',
            'In-depth evaluation of IT systems, controls, and processes to identify gaps and provide actionable recommendations.',
            'Delivery of clear, professional audit reports highlighting strengths, weaknesses, and prioritized remediation strategies.',
            'Guidance for audit preparation, including readiness assessments for ISO 27001, SOC 2, PCI DSS, HIPAA, and HITECH certifications.',
            'Commitment to transparency, timely delivery, and actionable outcomes that empower your organization to meet regulatory and industry standards confidently.',
          ],
        },
      ];
  return (
    <>
       <Helmet>
              <title>Cybersecurity and Audit Consulting Service</title>
              <meta name="description" content="At NagsPro, we specialize in providing exceptional cybersecurity consulting 
              services designed to help organizations navigate the evolving threat landscape.."/>
              <link rel="canonical" href="/Auditing"/>
            </Helmet>
  
    <div>
          <div className="container-fluid bg-primary py-5 mb-5 hero-header">
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">
          Cybersecurity and Audit Consulting Service
          </h1>
        </div>
      </div>
    </div>
  </div>
  <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
        <h1 className="mb-4">
        Cybersecurity and Audit Consulting Services by NagsPro
            </h1>
        <p className="mb-4">
        At NagsPro, we specialize in providing exceptional cybersecurity consulting 
        services designed to help organizations navigate the evolving threat landscape. 
        With CCISO-level expertise and deep proficiency in industry standards, we offer 
        customized solutions that align with your business goals and regulatory requirements.
            </p>
            <h4 className="mb-4">
            Our Promises
            </h4>
            <ul>
                <li>Improved Efficiency: Streamlined processes boost productivity.</li>
                <li>Reduced Risks: Minimize disruptions with proactive planning.</li>
                <li>Enhanced ROI: Effective resource allocation for better returns.</li>
                <li>Goal Alignment: Projects align with your business objectives.</li>
            </ul>
           
          </div>
          <div
            className="col-lg-6 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ minHeight: 400 }}
          >
            <div className="position-relative h-100">
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="https://www.cdaaudit.com//public/uploads/media/proper-auditing-service5f1abe737c429.jpg"
                alt="auditing"
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>
       
        </div>
      </div>
    </div>
      {/* card Start */}
      <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
   
  

    {/* <section class="process">
            <h2>  Our Core Services</h2>
            <ol>
                <li><strong>Cybersecurity Advisory & Risk Management</strong></li>
                <ul>
                <li>Comprehensive risk assessments leveraging frameworks like NIST CSF, NIST RMF, ISO 27001/2/5, ISO 31000, and CIS Controls.</li>
                <li>Tailored risk management strategies to mitigate vulnerabilities and enhance operational resilience.</li>
                <li>Vendor and third-party risk management solutions to secure your supply chain.</li>
            </ul>
                <li><strong> Information Security Management System (ISMS) Development</strong></li>
                <ul>
                <li>Implementation of robust ISMS frameworks tailored to your organizational needs.</li>
                <li>Establishment of security processes and standards to meet compliance and audit requirements.</li>
                <li>ISO 27001/2 readiness support to achieve and maintain certification.</li>
            </ul>
                <li><strong>Compliance and Certification Support</strong></li>
                <ul>
                <li>Expert guidance for achieving compliance with regulatory and industry standards, including SOC 2, PCI DSS, HIPAA, and HITECH.</li>
                <li>Comprehensive audit preparation, documentation, and evidence management to ensure certification success.</li>
                <li>Policy and procedure development aligned with client and industry expectations.</li>
            </ul>
                <li><strong> Governance, Risk, and Compliance (GRC) Solutions</strong> </li>
                <ul>
                <li>Seamless integration of GRC tools for effective risk monitoring and compliance tracking.</li>
                <li>Strategic alignment of cybersecurity policies with business objectives.</li>
                <li>Support for ongoing compliance with ISO 27001, SOC 2, PCI DSS, HIPAA, and other key standards.</li>
            </ul>
                <li><strong>Tailored Cybersecurity Consulting and Training</strong></li>
                <ul>
                <li>Custom training sessions to build awareness and expertise among your teams.</li>
                <li>Advisory engagements that align cybersecurity initiatives with organizational growth strategies.</li>
                <li>Development of client-specific deliverables, including detailed reports and actionable insights.</li>
            </ul>
                <li><strong>Professional IT Audit Consulting</strong></li>
                <ul>
                <li>Comprehensive IT audit services designed to assess and enhance your organization's security posture and compliance readiness.</li>
                <li>In-depth evaluation of IT systems, controls, and processes to identify gaps and provide actionable recommendations.</li>
                <li>Delivery of clear, professional audit reports highlighting strengths, weaknesses, and prioritized remediation strategies.</li>
                <li>Guidance for audit preparation, including readiness assessments for ISO 27001, SOC 2, PCI DSS, HIPAA, and HITECH certifications.</li>
                <li>Commitment to transparency, timely delivery, and actionable outcomes that empower your organization to meet regulatory and industry standards confidently.</li>
            </ul>
            </ol>
        </section> */}

 <section class="process">
<h2>Our Core  Cybersecurity & Audit Consulting Services</h2>
<div className="card-container">
   
      {services.map((service, index) => (
        <div className="carddy" key={index}>
          <img src={service.image} alt={service.title} className="card-image" />
          <h3 className="card-title">{service.title}</h3>
          <ul className="card-description">
            {service.description.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    </section>
        <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
          <div
            className="col-lg-6 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ minHeight: 400 }}
          >
            <div className="position-relative h-100">
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="https://www.ulyssesinfomedia.com/wp-content/uploads/2019/11/about-us1.png"
                alt="about"
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
         
            <h1 className="mb-4">
            Why Choose <span className="text-primary">NagsPro?</span>
            </h1>
            <ul>
                <li>     <i className="fa fa-arrow-right text-primary me-2" /><b>Certified Expertise:</b> Our consultants hold industry-leading certifications, including C|CISO, CISSP, CISM, and CRISC, ensuring you receive top-tier advisory services.
                </li>
                <li>   <i className="fa fa-arrow-right text-primary me-2" /><b>Proven Experience:</b> With a track record of successful certifications and implementations, we deliver results you can trust.</li>
                <li>   <i className="fa fa-arrow-right text-primary me-2" /><b>Client-Focused Solutions:</b> We prioritize your unique needs, offering personalized deliverables that drive value.</li>
                <li>   <i className="fa fa-arrow-right text-primary me-2" /><b>Project Management Excellence:</b> Our structured approach ensures the seamless execution of every engagement.</li>
                <li>   <i className="fa fa-arrow-right text-primary me-2" /><b>Audit Excellence:</b> With our professional audit services, you can expect a collaborative and results-driven process designed to meet your specific objectives.</li>
            </ul>
            <h3>Partner with NagsPro Today</h3>
            <p className="mb-4">
            At NagsPro, we are committed to helping you secure your organization and achieve compliance with confidence. 
            Let us strengthen your cybersecurity posture while you focus on achieving your business goals. Contact us today 
            to learn how we can transform your cybersecurity strategy.
            </p>
          </div>
        </div>
      </div>
    </div>

    <header className="hero">
                                <div className="hero-content">
                                    <h2>Let’s Build Your Digital Future</h2>
                                    <p>Partner with us to create innovative websites and seamless eCommerce solutions that drive results.</p>
                                    <a href='/Contact'><button className="contact-button">Contact Us</button></a>
                                </div>
                            </header>

<PopupWidget
                    url="https://calendly.com/nagspros"
                    rootElement={document.getElementById('root')}
                    text="Schedule a Consultation!"
                    textColor="#ffffff"
                    color="#346815FF"
                />
    </div>
    </div>
    </>
  )
}

export default Auditing
